const myportal = {
	banner: [{
		tips:'我的申请',
		fb_tips:"我的报告",
		title:'我的申请',
		content:'',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png'),
	}],
	label:{
		companyName:"公司名称：",
		productInfo:'产品简介：',
		sampleName:'产品名称：',
		productCategoryName:'产品类别：',
		status:'状态：',
		address:'产品生产地：',
		type:'申请类别：'
	},		
	mine_title:'我的申请',
	agree_title:'我的报告',
	down:"下载报告"	
}

export default myportal